
// import React, { useMemo, useEffect } from "react";
// import { useApp } from "../../../context/AppContext";
// import PageHeader from "../../../components/PageHeader/PageHeader";
// import StatCard from "../../../components/StatCard/StatCard";
// import DataTable from "../../../components/DataTable/DataTable";
// import StatusBadge from "../../../components/StatusBadge/StatusBadge";
// import "./Earnings.css";

// const ManagerEarnings = () => {
//   const {
//     orders = [],
//     settlements = [],
//     currentUser = null,
//     pumps = [],
//     // NEW from context:
//     managerSalesData = null,
//     managerSalesLoading = false,
//     fetchManagerSalesRecords,
//   } = useApp();

//   // Get current manager's pump (defensive)
//   const currentPump = useMemo(() => {
//     if (!currentUser || !Array.isArray(pumps)) return null;
//     return (
//       pumps.find((p) => {
//         if (!p) return false;
//         if (p.managerPhone && currentUser.phone) return String(p.managerPhone) === String(currentUser.phone);
//         if (p.manager_id && currentUser._id) return String(p.manager_id) === String(currentUser._id);
//         if (p.managerId && currentUser._id) return String(p.managerId) === String(currentUser._id);
//         return false;
//       }) || null
//     );
//   }, [pumps, currentUser]);

//   // Filter orders for this pump (safe)
//   const pumpOrders = useMemo(() => {
//     if (!currentPump || !Array.isArray(orders)) return [];
//     const pumpName = currentPump.pumpName ?? currentPump.name ?? currentPump.brand ?? null;
//     if (!pumpName) return [];
//     return orders.filter((o) => (o?.pumpName ?? o?.pump_name ?? "") === pumpName);
//   }, [orders, currentPump]);

//   // Filter settlements for this pump (safe)
//   const pumpSettlements = useMemo(() => {
//     if (!Array.isArray(settlements) || !currentPump) return [];
//     const pumpName = currentPump.pumpName ?? currentPump.name ?? currentPump.brand ?? null;
//     if (!pumpName) return [];
//     return settlements.filter(
//       (s) => s?.type === "pump" && ((s?.targetName ?? s?.target_name ?? "") === pumpName)
//     );
//   }, [settlements, currentPump]);

//   // LOCAL fallback calculation (defensive) — same logic as before
//   const localEarnings = useMemo(() => {
//     const completedOrders = pumpOrders.filter(
//       (o) =>
//         ((o?.orderStatus ?? o?.status ?? "").toString().toLowerCase() === "completed") &&
//         ((o?.paymentStatus ?? o?.payment_status ?? "").toString().toLowerCase() === "paid")
//     );

//     const totalOrders = completedOrders.length;
//     const totalVolume = completedOrders.reduce((sum, o) => sum + (Number(o?.quantityLiters ?? o?.fuel_quantity ?? o?.quantity_liters ?? 0) || 0), 0);
//     const totalEarnings = completedOrders.reduce((sum, o) => sum + (Number(o?.order_total ?? o?.amount ?? o?.total ?? 0) || 0), 0);

//     const commissionPercent = Number(currentPump?.commissionPercent ?? currentPump?.commission_percent ?? 0) || 0;
//     const platformCommission = totalEarnings * (commissionPercent / 100 || 0);
//     const netPayable = totalEarnings - platformCommission;

//     return {
//       totalOrders,
//       totalVolume,
//       totalEarnings,
//       platformCommission,
//       netPayable,
//     };
//   }, [pumpOrders, currentPump]);

//   // On mount: fetch server-side aggregates (safe no-op if function missing)
//   useEffect(() => {
//     if (typeof fetchManagerSalesRecords === "function") {
//       // If backend expects managerId param, context implementation will pass it.
//       fetchManagerSalesRecords().catch(() => {});
//     }
//   }, [fetchManagerSalesRecords, currentUser]);

//   // Decide which values to show: prefer server-provided managerSalesData.data shape
//   // expected server payload: { totalOrders, totalVolume, totalEarnings, netPayable }
//   const shownStats = useMemo(() => {
//     if (managerSalesData && (managerSalesData.totalOrders !== undefined || managerSalesData.totalEarnings !== undefined)) {
//       return {
//         totalOrders: Number(managerSalesData.totalOrders ?? 0),
//         totalVolume: Number(managerSalesData.totalVolume ?? 0),
//         totalEarnings: Number(managerSalesData.totalEarnings ?? 0),
//         netPayable: Number(managerSalesData.netPayable ?? managerSalesData.net_payable ?? 0),
//       };
//     }
//     return {
//       totalOrders: localEarnings.totalOrders,
//       totalVolume: localEarnings.totalVolume,
//       totalEarnings: localEarnings.totalEarnings,
//       netPayable: localEarnings.netPayable,
//     };
//   }, [managerSalesData, localEarnings]);

//   const settlementColumns = [
//     {
//       key: "period",
//       label: "Period",
//       render: (v) => v ?? "—",
//     },
//     {
//       key: "totalEarnings",
//       label: "Total Earnings",
//       render: (value) => `₹${(Number(value) || 0).toLocaleString("en-IN")}`,
//     },
//     {
//       key: "netPayable",
//       label: "Net Payable",
//       render: (value) => `₹${(Number(value) || 0).toLocaleString("en-IN")}`,
//     },
//     // {
//     //   key: "balanceDue",
//     //   label: "Balance Due",
//     //   render: (value) => `₹${(Number(value) || 0).toLocaleString("en-IN")}`,
//     // },
//     // {
//     //   key: "status",
//     //   label: "Status",
//     //   render: (value) => <StatusBadge status={value ?? "unknown"} type="settlement" />,
//     // },
//   ];

//   return (
//     <div className="manager-earnings">
//       <PageHeader title="Earnings" />

//       <div className="earnings-stats-grid">
//         <StatCard title="Total Orders" value={shownStats.totalOrders} subtitle="Completed orders" icon="📦" />
//         <StatCard title="Total Volume" value={`${shownStats.totalVolume} L`} subtitle="Liters delivered" icon="⛽" />
//         <StatCard
//           title="Total Earnings"
//           value={`₹${(Number(shownStats.totalEarnings) || 0).toLocaleString("en-IN")}`}
//           subtitle="Gross revenue"
//           icon="💰"
//         />
//         <StatCard
//           title="Net Payable"
//           value={`₹${(Number(shownStats.netPayable) || 0).toLocaleString("en-IN")}`}
//           subtitle="After commission"
//           icon="💵"
//         />
//       </div>

//       <div className="settlements-section">
//         <h2 className="section-title">Settlement History</h2>
//         <DataTable
//           columns={settlementColumns}
//           data={pumpSettlements}
//           searchable
//           searchPlaceholder="Search settlements..."
//           loading={managerSalesLoading}
//         />
//       </div>
//     </div>
//   );
// };

// export default ManagerEarnings;



import React, { useMemo, useEffect, useState, useCallback } from "react";
import { useApp } from "../../../context/AppContext";
import PageHeader from "../../../components/PageHeader/PageHeader";
import StatCard from "../../../components/StatCard/StatCard";
import DataTable from "../../../components/DataTable/DataTable";
import StatusBadge from "../../../components/StatusBadge/StatusBadge";
import { apiService } from "../../../services/api"; // <-- added
import "./Earnings.css";

const ManagerEarnings = () => {
  const {
    orders = [],
    settlements = [],
    currentUser = null,
    pumps = [],
    // NEW from context (may be null)
    managerSalesData = null,
    managerSalesLoading = false,
    fetchManagerSalesRecords,
  } = useApp();

  // Local state for server-side settlement history
  const [historyData, setHistoryData] = useState([]);
  const [localLoading, setLocalLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Get current manager's pump (defensive)
  const currentPump = useMemo(() => {
    if (!currentUser || !Array.isArray(pumps)) return null;
    return (
      pumps.find((p) => {
        if (!p) return false;
        if (p.managerPhone && currentUser.phone) return String(p.managerPhone) === String(currentUser.phone);
        if (p.manager_id && currentUser._id) return String(p.manager_id) === String(currentUser._id);
        if (p.managerId && currentUser._id) return String(p.managerId) === String(currentUser._id);
        return false;
      }) || null
    );
  }, [pumps, currentUser]);

  // Filter orders for this pump (safe)
  const pumpOrders = useMemo(() => {
    if (!currentPump || !Array.isArray(orders)) return [];
    const pumpName = currentPump.pumpName ?? currentPump.name ?? currentPump.brand ?? null;
    if (!pumpName) return [];
    return orders.filter((o) => (o?.pumpName ?? o?.pump_name ?? "") === pumpName);
  }, [orders, currentPump]);

  // Filter settlements for this pump (safe)
  const pumpSettlements = useMemo(() => {
    if (!Array.isArray(settlements) || !currentPump) return [];
    const pumpName = currentPump.pumpName ?? currentPump.name ?? currentPump.brand ?? null;
    if (!pumpName) return [];
    return settlements.filter(
      (s) => s?.type === "pump" && ((s?.targetName ?? s?.target_name ?? "") === pumpName)
    );
  }, [settlements, currentPump]);

  // LOCAL fallback calculation (defensive) — same logic as before
  const localEarnings = useMemo(() => {
    const completedOrders = pumpOrders.filter(
      (o) =>
        ((o?.orderStatus ?? o?.status ?? "").toString().toLowerCase() === "completed") &&
        ((o?.paymentStatus ?? o?.payment_status ?? "").toString().toLowerCase() === "paid")
    );

    const totalOrders = completedOrders.length;
    const totalVolume = completedOrders.reduce((sum, o) => sum + (Number(o?.quantityLiters ?? o?.fuel_quantity ?? o?.quantity_liters ?? 0) || 0), 0);
    const totalEarnings = completedOrders.reduce((sum, o) => sum + (Number(o?.order_total ?? o?.amount ?? o?.total ?? 0) || 0), 0);

    const commissionPercent = Number(currentPump?.commissionPercent ?? currentPump?.commission_percent ?? 0) || 0;
    const platformCommission = totalEarnings * (commissionPercent / 100 || 0);
    const netPayable = totalEarnings - platformCommission;

    return {
      totalOrders,
      totalVolume,
      totalEarnings,
      platformCommission,
      netPayable,
    };
  }, [pumpOrders, currentPump]);

  // On mount: optionally call context's fetch (no-op if missing)
  useEffect(() => {
    if (typeof fetchManagerSalesRecords === "function") {
      fetchManagerSalesRecords().catch(() => {});
    }
  }, [fetchManagerSalesRecords, currentUser]);

  // SERVER: fetch settlement history (manager payment history)
  const fetchManagerHistory = useCallback(
    async (search = "") => {
      try {
        setLocalLoading(true);
        const payload = await apiService.getManagerPaymentHistory(search);
        // API shape: { error:false, status:200, message:"Success", data: [ { period, total_earnings, net_payable } ] }
        const raw = Array.isArray(payload?.data) ? payload.data : [];
        const mapped = raw.map((r) => ({
          period: r.period ?? r.label ?? "—",
          // map API keys to the column keys expected by the table component
          totalEarnings: Number(r.total_earnings ?? r.totalEarnings ?? 0),
          netPayable: Number(r.net_payable ?? r.netPayable ?? 0),
          __raw: r,
        }));
        setHistoryData(mapped);
      } catch (err) {
        console.error("Failed to load manager payment history", err);
        setHistoryData([]);
      } finally {
        setLocalLoading(false);
      }
    },
    []
  );

  // fetch when component mounts and when searchTerm changes (debounce if desired)
  useEffect(() => {
    fetchManagerHistory(searchTerm).catch(() => {});
  }, [fetchManagerHistory, searchTerm]);

  // Decide which values to show: prefer server-provided managerSalesData.data shape
  const shownStats = useMemo(() => {
    if (managerSalesData && (managerSalesData.totalOrders !== undefined || managerSalesData.totalEarnings !== undefined)) {
      return {
        totalOrders: Number(managerSalesData.totalOrders ?? 0),
        totalVolume: Number(managerSalesData.totalVolume ?? 0),
        totalEarnings: Number(managerSalesData.totalEarnings ?? 0),
        netPayable: Number(managerSalesData.netPayable ?? managerSalesData.net_payable ?? 0),
      };
    }
    return {
      totalOrders: localEarnings.totalOrders,
      totalVolume: localEarnings.totalVolume,
      totalEarnings: localEarnings.totalEarnings,
      netPayable: localEarnings.netPayable,
    };
  }, [managerSalesData, localEarnings]);

  // table column definitions
  const settlementColumns = [
    {
      key: "period",
      label: "Period",
      render: (v) => v ?? "—",
    },
    {
      key: "totalEarnings",
      label: "Total Earnings",
      render: (value) => `₹${(Number(value) || 0).toLocaleString("en-IN")}`,
    },
    {
      key: "netPayable",
      label: "Net Payment",
      render: (value) => `₹${(Number(value) || 0).toLocaleString("en-IN")}`,
    },
  ];

  // combined loading: prefer context loading flag but include local fetch loading
  const combinedLoading = Boolean(managerSalesLoading) || localLoading;

  return (
    <div className="manager-earnings">
      <PageHeader title="Earnings" />

      <div className="earnings-stats-grid">
        <StatCard title="Total Orders" value={shownStats.totalOrders} subtitle="Completed orders" icon="📦" />
        <StatCard title="Total Volume" value={`${shownStats.totalVolume} L`} subtitle="Liters delivered" icon="⛽" />
        <StatCard
          title="Total Earnings"
          value={`₹${(Number(shownStats.totalEarnings) || 0).toLocaleString("en-IN")}`}
          subtitle="Gross revenue"
          icon="💰"
        />
        <StatCard
          title="Net Payable"
          value={`₹${(Number(shownStats.netPayable) || 0).toLocaleString("en-IN")}`}
          subtitle="After commission"
          icon="💵"
        />
      </div>

      <div className="settlements-section">
        <h2 className="section-title">Settlement History</h2>

        {/* server-side search input (DataTable internal search can be disabled if you want) */}
        <div style={{ marginBottom: 12, maxWidth: 420 }}>
          <input
            placeholder="Search period..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: "100%", padding: "8px 10px", borderRadius: 6, border: "1px solid #ddd" }}
          />
        </div>

        <DataTable
          columns={settlementColumns}
          data={historyData}               // <-- use server mapped data here
          searchable={false}               // we've implemented server-side search above
          searchPlaceholder="Search settlements..."
          loading={combinedLoading}
          emptyMessage="No settlement history available."
        />
      </div>
    </div>
  );
};

export default ManagerEarnings;
